import { connect } from 'react-redux';

import { requestSignUpOtp, verifySignUpOtp, resetMeta, resetPage } from '../../actions/SignUpPage';
import SignUpVerificationPage from './SignUpVerificationPage';

const mapsStateToProps = state => ({
	signUpPageProps: state.signUpPageReducer,
	loginPageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	requestSignUpOtp(options) {
		dispatch(requestSignUpOtp(options));
	},
	verifySignUpOtp(options) {
		dispatch(verifySignUpOtp(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(SignUpVerificationPage);
